var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('d3-chart',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowPsiBoxPlot),expression:"isShowPsiBoxPlot"}],attrs:{"options":_vm.psiChartOptions}})}
var staticRenderFns = []

export { render, staticRenderFns }